import { gql } from '@apollo/client';

import TASK_FRAGMENT from 'components/projects/taskList/gql/TaskFragment.graphql';

export default gql`
  fragment TaskListSectionsFragment on TaskList {
    id
    uuid
    taskListSections(first: $first, after: $after)
      @connection(key: "taskListSections") {
      __typename
      nodes {
        __typename
        id
        position
        title
        skippable
        skippedAt
        skippedBy {
          id
          name
        }
        tasks {
          __typename
          nodes {
            ...TaskFragment
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${TASK_FRAGMENT}
`;
